import { render, staticRenderFns } from "./testPaperList.vue?vue&type=template&id=3f669fc8"
import script from "./testPaperList.vue?vue&type=script&lang=js"
export * from "./testPaperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports